import React, { useMemo } from 'react';
import { BetType, BetTypeRectangleTableBottom, BetTypeTableLeftColumns } from '../../enums/tableNumbers';
import { uuid } from '../../helpers/uuid';
import { useTranslation } from '@pascal/pascal-core';
const { Dozen_1, Dozen_2, Dozen_3, Numbers_1_18, Even, Red, Black, Odd, Numbers_19_36 } = BetTypeRectangleTableBottom;
export const DiagramsWrapper = ({ statistics, isBetShop = false }) => {
  const t = useTranslation();
  const statisticResults = useMemo(() => {
    if (statistics?.combinationStatistic) {
      const blackChipsPercent = statistics.combinationStatistic['black'].percent;
      const redChipsPercent = statistics.combinationStatistic['red'].percent;
      const oddNumbers = statistics.combinationStatistic['odd'].percent;
      const evenNumbers = statistics.combinationStatistic['even'].percent;
      const numbers1_18 = statistics.combinationStatistic['numbers_1_18'].percent;
      const numbers19_36 = statistics.combinationStatistic['numbers_19_36'].percent;
      const number0 = statistics.combinationStatistic['number_0'].percent;
      const dozen1_12 = statistics.combinationStatistic['dozen_1'].percent;
      const dozen13_24 = statistics.combinationStatistic['dozen_2'].percent;
      const dozen25_36 = statistics.combinationStatistic['dozen_3'].percent;
      const column_1 = statistics.combinationStatistic['column_1'].percent;
      const column_2 = statistics.combinationStatistic['column_2'].percent;
      const column_3 = statistics.combinationStatistic['column_3'].percent;
      const hotNumbers = statistics.hotNumbers;
      const coldNumbers = statistics.coldNumbers;
      return {
        redChipsPercent,
        blackChipsPercent,
        oddNumbers,
        evenNumbers,
        numbers1_18,
        numbers19_36,
        number0,
        dozen1_12,
        dozen13_24,
        dozen25_36,
        column_1,
        column_2,
        column_3,
        hotNumbers,
        coldNumbers,
      };
    }
  }, [statistics]);

  return (
    <div className='diagrams-wrp'>
      {isBetShop ? null : (
        <div className='diagrams-top-box'>
          <div className='diagrams-top-inn-box'>
            <div className='diagrams-t-inn-cont-l fire'>
              <span className='icon-fire' />
            </div>
            <div className='diagrams-t-inn-cont-r'>
              {statisticResults?.hotNumbers.map((item) => {
                return (
                  <span key={uuid()} data={BetType[`StraightUp_${item}`]}>
                    {item}
                  </span>
                );
              })}
            </div>
          </div>
          <div className='diagrams-top-inn-box'>
            <div className='diagrams-t-inn-cont-l snow'>
              <span className='icon-snowflake' />
            </div>
            <div className='diagrams-t-inn-cont-r'>
              {statisticResults?.coldNumbers.map((item) => {
                return (
                  <span key={uuid()} data={BetType[`StraightUp_${item}`]}>
                    {item}
                  </span>
                );
              })}
            </div>
          </div>
        </div>
      )}
      <div className='diagrams-mid-box'>
        <div className='inner-diagram-wrp color'>
          <div className='left-side red' data={Red} style={{ width: `${statisticResults?.redChipsPercent}%` }}>
            <p className='mid-diagram-text' data={Red}>
              {t('RED')}
            </p>
            <p className='mid-diagram-percent' data={Red}>
              {statisticResults?.redChipsPercent}%
            </p>
          </div>
          <div className='right-side black' data={Black} style={{ width: `${statisticResults?.blackChipsPercent}%` }}>
            <p className='mid-diagram-percent' data={Black}>
              {statisticResults?.blackChipsPercent}%
            </p>
            <p className='mid-diagram-text' data={Black}>
              {t('BLACK')}
            </p>
          </div>
        </div>
        <div className='inner-diagram-wrp odd-even'>
          <div className='left-side gray' data={Odd} style={{ width: `${statisticResults?.oddNumbers}%` }}>
            <p className='mid-diagram-text' data={Odd}>
              {t('ODD')}
            </p>
            <p className='mid-diagram-percent' data={Odd}>
              {statisticResults?.oddNumbers}%
            </p>
          </div>
          <div className='right-side black' data={Even} style={{ width: `${statisticResults?.evenNumbers}%` }}>
            <p className='mid-diagram-percent' data={Even}>
              {statisticResults?.evenNumbers}%
            </p>
            <p className='mid-diagram-text' data={Even}>
              {t('EVEN')}
            </p>
          </div>
        </div>
        <div className='inner-diagram-wrp numbers-count'>
          <div className='left-side gray' data={Numbers_1_18} style={{ width: `${statisticResults?.numbers1_18}%` }}>
            <p className='mid-diagram-text' data={Numbers_1_18}>
              1-18
            </p>
            <p className='mid-diagram-percent' data={Numbers_1_18}>
              {statisticResults?.numbers1_18}%
            </p>
          </div>
          <div
            className='right-side black'
            data={Numbers_19_36}
            style={{ width: `${statisticResults?.numbers19_36}%` }}
          >
            <p className='mid-diagram-percent' data={Numbers_19_36}>
              {statisticResults?.numbers19_36}%
            </p>
            <p className='mid-diagram-text' data={Numbers_19_36}>
              19-36
            </p>
          </div>
        </div>
        <div className='inner-diagram-wrp number' data={BetType.StraightUp_0}>
          <div
            className='left-side green'
            data={BetType.StraightUp_0}
            style={{ width: `${statisticResults?.number0}%` }}
          >
            <p className='mid-diagram-text' data={BetType.StraightUp_0}>
              0
            </p>
            <p className='mid-diagram-percent' data={BetType.StraightUp_0}>
              {statisticResults?.number0}%
            </p>
          </div>
          <div className='right-side' data={BetType.StraightUp_0}>
            <p className='mid-diagram-percent' />
            <p className='mid-diagram-text' />
          </div>
        </div>
      </div>
      <div className='diagrams-bottom-box'>
        <div className='diagrams-bottom-title-wrp'>
          <p className='diagrams-bottom-title'>{t('DOZENS')}</p>
          <p className='diagrams-bottom-title'>{t('COLUMN')}</p>
        </div>
        <div className='inner-diagram-wrp quarters first'>
          <div className='left-side gray' data={Dozen_1} style={{ width: `${statisticResults?.dozen1_12}%` }}>
            <p className='mid-diagram-text' data={Dozen_1}>
              1st12
            </p>
            <p className='mid-diagram-percent' data={Dozen_1}>
              {statisticResults?.dozen1_12}%
            </p>
          </div>
          <div
            className='right-side black'
            data={BetTypeTableLeftColumns.Column_1}
            style={{ width: `${statisticResults?.column_1}%` }}
          >
            <p className='mid-diagram-percent' data={BetTypeTableLeftColumns.Column_1}>
              {statisticResults?.column_1}%
            </p>
            <p className='mid-diagram-text' data={BetTypeTableLeftColumns.Column_1}>
              1
            </p>
          </div>
        </div>
        <div className='inner-diagram-wrp quarters second'>
          <div className='left-side gray' data={Dozen_2} style={{ width: `${statisticResults?.dozen13_24}%` }}>
            <p className='mid-diagram-text' data={Dozen_2}>
              2nd12
            </p>
            <p className='mid-diagram-percent' data={Dozen_2}>
              {statisticResults?.dozen13_24}%
            </p>
          </div>
          <div
            className='right-side black'
            data={BetTypeTableLeftColumns.Column_2}
            style={{ width: `${statisticResults?.column_2}%` }}
          >
            <p className='mid-diagram-percent' data={BetTypeTableLeftColumns.Column_2}>
              {statisticResults?.column_2}%
            </p>
            <p className='mid-diagram-text' data={BetTypeTableLeftColumns.Column_2}>
              2
            </p>
          </div>
        </div>
        <div className='inner-diagram-wrp quarters third'>
          <div className='left-side gray' data={Dozen_3} style={{ width: `${statisticResults?.dozen25_36}%` }}>
            <p className='mid-diagram-text' data={Dozen_3}>
              3nd12
            </p>
            <p className='mid-diagram-percent' data={Dozen_3}>
              {statisticResults?.dozen25_36}%
            </p>
          </div>
          <div
            className='right-side black'
            data={BetTypeTableLeftColumns.Column_3}
            style={{ width: `${statisticResults?.column_3}%` }}
          >
            <p className='mid-diagram-percent' data={BetTypeTableLeftColumns.Column_3}>
              {statisticResults?.column_3}%
            </p>
            <p className='mid-diagram-text' data={BetTypeTableLeftColumns.Column_3}>
              3
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
